import styled from 'styled-components';
import colors from 'constants/colors';

export const OverviewContainer = styled.table`
  width: 100%;
  border-collapse: separate; 
  border-spacing: 0;
  box-sizing: border-box;

  thead {
    color: ${colors.silver};
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 1px;
    margin-bottom: 16px;
  }

  tbody {
    tr {
      position: relative;
      height: 53px;
      outline-width: 1px;
      outline-style: solid;
      outline-color: ${colors.black2};
      cursor: pointer;
    }
    tr:hover td {
      background-color: ${colors.charcoal}; 
    }
    tr:active td {
      background-color: ${colors.black4}; 
    }
    tr.active {
      outline-color: ${colors.green};
      z-index: 10;
    }
    tr::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 16px;  
      right: 16px; 
      height: 1px;
      background-color: ${colors.darkGrey};
      z-index: 1;
    }
    tr:last-child::after {
      display: none;
    }
  }

  .date {
    width: 40%;
    padding-left: 16px;
  }

  .rooms {
    width: 40%;
  }

  .breakfasts {
    width: 20%;
    padding-right: 16px;
  }
`;

export const Row = styled.tr`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid ${colors.black5};
`;


export const NavigatorContainer = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 10px;

  /* @media only screen and (max-width: 1200px) {
    justify-content: center;
  } */
`;

export const Navigator = styled.div`
  color: ${colors.lightBlue};
  font-size: 13px;
  font-weight: bold;
  cursor: pointer;

  /* @media only screen and (max-width: 1200px) {
    display: none;
  } */

  ${(props) => props.disabled ? `
    pointer-events:none;
    color: ${colors.dimGrey}
  `: null }
`;
